import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { useAppDispatch } from "../../../../app/hooks";
import CheckLoading from "../../../../features/base/CheckLoading";
import { ElementMissingContext } from "../../../../features/base/ElementMissingContext";
import ObjectInsUpd from "../../../../features/base/page/ObjectInsUpd";
import { selectSubjectInsUpd, subjectInsert, subjectInsUpdSlice, subjectUpdate } from "../../../../redux/curriculum/subjectInsUpdSlice";
import { subjectListSlice } from "../../../../redux/curriculum/subjectListSlice";
import { selectSubject, subjectSlice } from "../../../../redux/curriculum/subjectSlice";
import { schoolSlice, selectSchool } from "../../../../redux/school/schoolSlice";
import { routeSchool } from "../../../../routes/school";
import { SubjectInsUpdData } from "./SubjectInsUpdData";
import { SubjectInsUpdReview } from "./SubjectInsUpdReview";
import { SubjectInfo } from "../../../../redux/curriculum/model";

export interface SubjectInsUpdProps {
    back: () => void;
    schoolId: string;
    subject?: SubjectInfo;
}

export function SubjectInsUpd({ back, schoolId, subject }: SubjectInsUpdProps) {
    const dispatch = useAppDispatch();
    const subjectInsUpd = useSelector(selectSubjectInsUpd);

    const editing = subject !== undefined;

    if (editing) {
        if (subjectInsUpd.subject.schoolId <= 0 && subject) {
            const changing = {
                ...subject
            };
            dispatch(subjectInsUpdSlice.actions.set(changing));
        }
    } else {
        if (subjectInsUpd.subject.schoolId <= 0) {
            const changing = {} as SubjectInfo;
            changing.schoolId = Number(schoolId);
            dispatch(subjectInsUpdSlice.actions.set(changing));
        }
    }

    const steps = [
        {
            name: "Dados da Disciplina",
            component: <SubjectInsUpdData />,
            check: () => `${subjectInsUpd.subject.name}`.length > 1,
        },
        {
            name: "Revisão",
            component: <SubjectInsUpdReview />,
        }
    ];

    const buildContent = () =>
        <ObjectInsUpd
            name="disciplina"
            submit={() =>
                (editing)
                    ? dispatch(subjectUpdate({ subjectId: `${subject!.id}`, subject: subjectInsUpd.subject }))
                    : dispatch(subjectInsert({ subject: subjectInsUpd.subject }))
            }
            backTo={back}
            backCleanup={() => {
                dispatch(subjectListSlice.actions.clean());
                dispatch(subjectInsUpdSlice.actions.clean());
            }}
            state={subjectInsUpd.state}
            steps={steps}
            edit={editing}
        />
        ;

    return buildContent();
    // return <CheckLoading
    //     key="editUpdateSubject"
    //     states={editing ? [state] : [state]}
    //     content={buildContent}
    //     error="Erro ao carregar disciplina"
    //     retry={() => {
    //         dispatch(schoolSlice.actions.clean());
    //         dispatch(subjectSlice.actions.clean());
    //     }}
    // />;

}
